import { format, isToday, isYesterday, startOfWeek, parseISO } from "date-fns";

/**
 * Formats a given date to a relative label:
 * - "8:08 AM" if today  (or "Today" if useTodayLabel is true)
 * - "Yesterday" if yesterday (before today)
 * - "Friday" if within the current week (starting Sunday)
 * - "Nov 11th" otherwise
 *
 * @param {string|Date} date - The date to format
 * @param {boolean} [useTodayLabel=false] - Show "Today" instead of time for today's dates
 * @returns {string}
 */
export function formatMessageTimestamp(date, useTodayLabel = false) {
  let parsedDate;

  if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
    const [year, month, day] = date.split("-");
    parsedDate = new Date(year, month - 1, day);
  } else {
    parsedDate = new Date(date);
  }

  if (isToday(parsedDate)) {
    return useTodayLabel ? "Today" : format(parsedDate, "p");
  }

  if (isYesterday(parsedDate)) {
    return "Yesterday";
  }

  const weekStart = startOfWeek(new Date(), { weekStartsOn: 0 });
  if (parsedDate >= weekStart) {
    return format(parsedDate, "EEEE");
  }

  return format(parsedDate, "MMM do");
}
